import { Controller } from "@hotwired/stimulus"
import { Turbo } from "@hotwired/turbo-rails"

export default class extends Controller {
  static values = { url: String }

  refresh() {
    clearTimeout(this.timeout)
    this.timeout = setTimeout(() => this.requestPreview(), 200)
  }

  async requestPreview() {
    if (!this.hasUrlValue) return

    const token = document.querySelector('meta[name="csrf-token"]')?.getAttribute("content")
    const formData = new FormData(this.element)

    const response = await fetch(this.urlValue, {
      method: "POST",
      headers: {
        Accept: "text/vnd.turbo-stream.html",
        "X-CSRF-Token": token || ""
      },
      credentials: "same-origin",
      body: formData
    })

    if (!response.ok) return

    Turbo.renderStreamMessage(await response.text())
  }
}
